import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { debounce } from "lodash";
import { ForwardButton, BackButton, DisplayErrors } from "./Survey.jsx";
import { Add, AccountClose } from '../../Common/Buttons/Icons';
import { Trans } from 'react-i18next';

class FleetAccountsQuestion extends Component {
    constructor(props) {
        super(props);

        //Allows use of state and this in the handlechange function
        this.localValidation = debounce(this.localValidation.bind(this), 500);
        this.loadSurvey = debounce(this.loadSurvey.bind(this), 500);
        this.checkIfJson = this.checkIfJson.bind(this);
        this.addAccountEntry = this.addAccountEntry.bind(this);
        this.removeAccountEntry = this.removeAccountEntry.bind(this);
        this.selectOEM = this.selectOEM.bind(this);
        this.updateAccountNumber = this.updateAccountNumber.bind(this);
        this.checkAccountCheckbox = this.checkAccountCheckbox.bind(this);
        this.generateAccountEntries = this.generateAccountEntries.bind(this);
        this.fetchSelectedOEM = this.fetchSelectedOEM.bind(this);

        this.state = {
            errors: {account: {1: {oem: false, number: false, checkbox: false}}},
            response: [],
            account: {},
            account_entries: 1,
        };
    }

    componentDidMount() {
        var self = this;
        var account = self.state.account;
        var errors = self.state.errors;
        var account_entries = self.state.account_entries;

        if(self.props.responses.length > 0)
        {
            account_entries = self.props.responses.length;
            self.props.responses.forEach(function (resp, index) {
                account[(index + 1)] = {oem: self.fetchSelectedOEM(self.props.options, resp, index), number: (resp.Answer == "N/A" ? "" : resp.Answer), checkbox: (resp.Answer == "N/A" ? true : false)};
                errors.account[(index + 1)] = {oem: false, number: false, checkbox: false};
            });

            self.setState({
                account_entries: account_entries,
                errors: errors
            });
        }
    }

    localValidation(e, props) {
        var self = this;
        var account = self.state.account;
        var response = [];
        var errors = self.state.errors;
        var account_entries = self.state.account_entries;
        var error_flag = false;

        if($("#required_" + props.question.Id).val() === "true" && Object.keys(account).length == 0)
        {
            errors = {account: {1: {oem: true, number: true, checkbox: true}}}

            self.setState({
                errors: errors
            });

            return
        }
        else
        {
            Object.keys(account).forEach(function(key, index) 
            {
                if(account[key].oem != null && (account[key].number == "" && account[key].checkbox == false))
                {
                    errors.account[key].number = true;
                    errors.account[key].checkbox = true;
                }
                else if(account[key].oem == null  && (account[key].number != "" || account[key].checkbox != false))
                {
                    errors.account[key].oem = true;
                }
            });
        }

        self.setState({
            errors: errors
        });

        Object.keys(account).forEach(function(key, index) 
        {
            if(errors.account[key].oem || errors.account[key].number || errors.account[key].checkbox)
            {
                error_flag = true
            }

            response.push({"answer": account[key].oem.value, "answer_choice": (account[key].checkbox ? "N/A" : account[key].number)});
        });

        if(!error_flag)
        {
            var response2 = {question_id: props.question.Id, "answer": response};
            props.handleResponse(e, props, response2);
        }
    }

    loadSurvey(e, props, action) {
        props.loadSurvey(e, props, action);
    }

    addAccountEntry() {
        var self = this;
        var account_entries = self.state.account_entries;
        var errors = self.state.errors;

        if(account_entries < 4)
        {
            account_entries++;
            errors.account[account_entries] = {oem: false, number: false, checkbox: false};
        }

        self.setState({
            account_entries: account_entries,
            errors: errors
        });
    }

    removeAccountEntry(event) {
        var self = this;
        var account = self.state.account;
        var account_entries = self.state.account_entries;
        var row = event.currentTarget.dataset.row
        var errors = self.state.errors;

        Object.keys(account).forEach(function(key, index) 
        {
            if(key == row)
            {
                delete account[row];
            }
            else if(key > row)
            {
                if(Object.keys(account).length >= (key - 1))
                {
                    account[(key - 1)] = account[key];
                }

                delete account[key];
            }
        });

        Object.keys(errors.account).forEach(function(key, index) 
        {
            if(key == row)
            {
                delete errors.account[row];
            }
            else if(key > row)
            {
                if(Object.keys(account).length >= (key - 1))
                {
                    errors.account[(key - 1)] = errors.account[key];
                }

                delete errors.account[key];
            }
        });

        if(account_entries > 1)
        {
            account_entries--;
        }

        self.setState({
            account: account,
            account_entries: account_entries,
            errors: errors
        });
    }

    selectOEM(event) {
        var self = this;
        var account = self.state.account;
        var errors = self.state.errors;
        var row = event.row;

        if(row in account)
        {
            account[row].oem = event;
        }
        else
        {
            account[row] = {oem: event, number: "", checkbox: false};
        }

        if(row in errors["account"] && errors["account"][row]["oem"])
        {
            errors["account"][row]["oem"] = false;
        }

        self.setState({
            account: account,
            errors: errors
        });
    }

    updateAccountNumber(event) {
        var self = this;
        var account = self.state.account;
        var errors = self.state.errors;
        var row = event.target.dataset.row;

        if(row in account)
        {
            account[row].number = event.target.value;
        }
        else
        {
            account[row] = {oem: null, number: event.target.value, checkbox: false};
        }

        if(row in errors["account"] && errors["account"][row]["number"])
        {
            errors["account"][row]["number"] = false;
            errors["account"][row]["checkbox"] = false;
        }

        self.setState({
            account: account,
            errors: errors
        });
    }

    checkAccountCheckbox(event) {
        var self = this;
        var account = self.state.account;
        var errors = self.state.errors;
        var row = event.target.dataset.row;

        if(row in account)
        {
            account[row].checkbox = event.target.checked;
        }
        else
        {
            account[row] = {oem: null, number: "", checkbox: event.target.checked};
        }

        if(row in errors["account"] && errors["account"][row]["checkbox"])
        {
            errors["account"][row]["checkbox"] = false;
            errors["account"][row]["number"] = false;
        }

        self.setState({
            account: account,
            errors: errors
        });
    }

    generateAccountEntries() {
        var entries = []

        for (var count = this.state.account_entries - 1, row = 1; count >= 0; count--, row++)
        {
            entries.push(
                <div className="survey-question-account-row">
                    <div className="mobile survey-column-header">
                        Name of OEM
                    </div>
                    <div className="survey-question-add-row">
                    </div>
                    <div className="survey-question-account-name">
                        <div className="survey-question-selectbox" key={"selectbox-" + row + (row in this.state.account && this.state.account[row]["oem"] != null ? ("-" + this.state.account[row]["oem"]["value"]) : "")}>
                            <Select 
                                options={
                                    this.props.options.map((option) => {
                                        return(
                                            {value: option.Id, label: option.Text, row: row}
                                        )
                                    })
                                }
                                style={{width: "100%", height:'36px'}}
                                placeholder={ this.checkIfJson(this.props.question.Help_Text) && "placeholder" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).placeholder[0] : "" }
                                className={"react_select_dropdown" + (row in this.state.errors.account && this.state.errors.account[row]["oem"] ? " selectbox-error" : "")}
                                classNamePrefix="react_select"
                                defaultValue={row in this.state.account && this.state.account[row]["oem"] != null ? {value: this.state.account[row]["oem"]["value"], label: this.state.account[row]["oem"]["label"], row: this.state.account[row]["oem"]["row"]} : {}}
                                onChange={(event) => this.selectOEM(event)}
                            />
                        </div>
                    </div>
                    <div className="mobile survey-column-header">
                        Fleet Account Number
                    </div>
                    <div className="survey-question-account-number">
                        <div className={"survey-account-container" + (row in this.state.errors.account && this.state.errors.account[row]["number"] ? " survey-account-container-error" : "")}>
                            <input type="text" placeholder={ this.checkIfJson(this.props.question.Help_Text) && "placeholder" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).placeholder[1] : "" } className="survey-account-number" data-row={row} value={row in this.state.account ? this.state.account[row]["number"] : ""} onChange={(event) => this.updateAccountNumber(event)} />
                            <label className="survey-account-checkbox-label">
                                <input type="checkbox" data-row={row} checked={row in this.state.account ? this.state.account[row]["checkbox"] : ""} onChange={(event) => this.checkAccountCheckbox(event)} />
                                <span className={"survey-account-checkbox-custom"  + (row in this.state.errors.account && this.state.errors.account[row]["checkbox"] ? " checkbox-error" : "")}></span>
                                <span className="survey-account-checkbox-text"><Trans>I don't know</Trans></span>
                            </label>
                        </div>
                    </div>
                    {
                        this.state.account_entries > 1 || 1 in this.state.account ?
                            <div className="survey-question-remove-row" data-row={row} onClick={(event) => this.removeAccountEntry(event)}>
                                {AccountClose()}
                            </div>
                        :
                            <div className="survey-question-remove-row">
                            </div>
                    }
                </div>
            )
        }

        if(this.state.account_entries < 4)
        {
            entries.push(
                <div className="survey-question-account-row new-account-row">
                    <div className="mobile survey-column-header">
                        Name of OEM
                    </div>
                    <div className="survey-question-add-row" onClick={() => this.addAccountEntry()}>
                        {Add("fill-primary")}
                    </div>
                    <div className="survey-question-account-name">
                        <div className="survey-question-selectbox">
                            <Select 
                                style={{width: "100%", height:'36px'}}
                                placeholder={ this.checkIfJson(this.props.question.Help_Text) && "placeholder" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).placeholder[0] : "" }
                                className={"react_select_dropdown"}
                                classNamePrefix="react_select"
                            />
                        </div>
                    </div>
                    <div className="mobile survey-column-header">
                        Fleet Account Number
                    </div>
                    <div className="survey-question-account-number">
                        <div className="survey-account-container">
                            <input type="text" className="survey-account-number" placeholder={ this.checkIfJson(this.props.question.Help_Text) && "placeholder" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).placeholder[1] : "" } />
                            <label className="survey-account-checkbox-label">
                                <input type="checkbox" />
                                <span className="survey-account-checkbox-custom"></span>
                                <span className="survey-account-checkbox-text"><Trans>I don't know</Trans></span>
                            </label>
                        </div>
                    </div>
                    <div className="survey-question-remove-row">
                    </div>
                </div>
            )
        }

        return entries;
    }

    fetchSelectedOEM(options, response, index) {
        var selected_oem = {};

        if(!jQuery.isEmptyObject(options)) {
            $.each(options, function(i, option) {
                if(option.Id == response.Response_Choice_Id)
                {
                    selected_oem = {value: option.Id, label: option.Text, key: (index+1)};
                }
            });
        }

        return selected_oem;
    }

    checkIfJson(json) {
        try {
            JSON.parse(json);
        } catch (e) {
            return false;
        }

        return true;
    }
    
    render() {
        return (
            <>
                <div className="registration-main">
                    <div className={"survey-questions-container question-" + (this.props.page)}>
                        <div className="survey-question-text">{ this.props.question.Text }</div>
                        <div className="survey-question-description">{ this.checkIfJson(this.props.question.Help_Text) && "description" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).description : "" }</div>
                        <div className="survey-question-account">
                            <div className="survey-question-account-row">
                                <div className="survey-question-add-row">
                                </div>
                                <div className="survey-question-account-name">
                                    <div className="survey-question-text desktop"><Trans>Name of OEM</Trans></div>
                                </div>
                                <div className="survey-question-account-number">
                                    <div className="survey-question-text desktop"><Trans>Fleet Account Number</Trans></div>
                                </div>
                                <div className="survey-question-remove-row">
                                </div>
                            </div>
                            { this.generateAccountEntries() }
                        </div>
                    </div>
                    <input type='hidden' name={'required_' + this.props.question.Id} id={'required_' + this.props.question.Id} value={ (this.props.question.Validation).includes("required") ? true : false }/>
                </div> 

                <div className="registration-actions">
                    {
                        this.props.question.question_orders.length == 0 || this.props.question.question_orders[0].Question_Order != 1 ?
                            <div className="registration-left">
                                <span onClick={(e) => this.loadSurvey(e, this.props, 'previous')} className="primary medium">
                                    <i className="fas fa-arrow-left" style={{marginRight: "20px"}}></i>
                                    <span><Trans>Back</Trans></span>
                                </span>
                            </div>
                        :
                            null
                    }
                    <div className="registration-right">
                        <span onClick={(e) => this.localValidation(e, this.props)} className={"primary medium registration-button " + ((this.props.question.Validation).includes("required") && jQuery.isEmptyObject(this.state.account) ? "disabled" : "registration-active")} style={{marginLeft: "20px"}}>
                            <span><Trans>Next</Trans></span>
                            <i className="fas fa-arrow-right" style={{marginLeft: "40px"}}></i>
                        </span>
                    </div>
                </div>
            </>   
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(FleetAccountsQuestion);